/**
 * Web Dev Custom Script
 */

jQuery(document).ready(function($) {
  var idx = 0;
  var mouseover = false;
  var maxleng = $(".announcement-bar .content_item").length;
  if(maxleng > 0){
    next_announcement_item();
    setInterval(next_announcement_item, 5000);
  }
  $(".announcement-bar").mouseover(function(){
    mouseover = true;
  });
  $(".announcement-bar").mouseleave(function(){
    mouseover = false;
    $(".announcement-bar .content_item .ann_item_content").removeClass("active");
  });
  $(".announcement-bar .content_item .ann_item").click(function(){
    $(this).closest(".content_item").find(".ann_item_content").addClass("active");
  });

  function next_announcement_item(){
    if(!mouseover){
      if(idx == maxleng)idx = 0;
      idx++;
      $(".announcement-bar .content_item .ann_item_content").removeClass("active");
      $(".announcement-bar .content_item").removeClass("active");
      $(".announcement-bar .content_item:nth-child("+idx+")").addClass("active");
    }
  }

        $(window).on('scroll', function() {
            const element = $(".question-about-email");
            const scrollTop = $(window).scrollTop();
            const windowHeight = $(window).height();
            const elementOffsetTop = element.offset().top;
            const elementHeight = element.height();

            if (scrollTop > elementOffsetTop) {
              $('.product-form-wrapper').addClass('displayed');
            }else{
              $('.product-form-wrapper').removeClass('displayed');
            }
        });

  $(document).on("click", ".description-header", function(e){
    let parentEle = $(this).closest(".product-single__description");
    if(parentEle.hasClass("expanded")){
      parentEle.removeClass("expanded");
    }else{
      parentEle.addClass("expanded");
    }
  });
  $(document).on("click", ".product-promopickup label", function(e){
    $(".product-promopickup label").removeClass("active");
    $(this).addClass("active");
  });
  $(document).on("click", ".product-promopickup", function(e){
    if(e.target.className == "" || e.target.className == "product-promopickup"){
      let title = "Local to Denver? Choose pickup and get a free gift card!";
      let content = "Select pickup when you add this item to your cart and a gift card for your next purchase will automatically be added to your cart for free! Our pickup location is 3869 Steele St #1163, Denver CO 80205. When you check out, make sure to select local pick up on the checkout page or the card will be invalidated. You'll receive your gift card to the email address you use at checkout.";
      content += '<img src="https://cdn.shopify.com/s/files/1/0797/8565/6598/files/v3_OBO_Map.png?v=1712689668" />'
      $(".pdp-popup h6").html(title);
      $(".pdp-popup .content").html(content);
      $(".pdp-popup").show();
    }
  });
  $(document).on("click", ".product-promo", function(e){
    e.preventDefault();
    let title = "Claiming your gift card is easy!";
    let content = "Just add this item to your cart and your gift card will automatically be added as well. When you check out, a credit for the amount of the gift card will be added to your purchase and you wont be charged for it. You'll receive your gift card to the email address you use at checkout and you can use the gift card on any future purchase.";
    $(".pdp-popup h6").html(title);
    $(".pdp-popup .content").html(content);
    $(".pdp-popup").show();
  });
  $(document).on("click", ".cs-product-template .cs-container .cs-grid .cs-content .cs-info p a", function(e){
    e.preventDefault();
    let title = $(this).text();
    let content_class = $(this).data("content");
    console.log(content_class);
    let content = $(this).closest(".cs-info").find("."+content_class).html();
    $(".pdp-popup h6").html(title);
    $(".pdp-popup .content").html(content);
    $(".pdp-popup").show();
  });
  $(document).on("click", ".pdp-popup .fa-times", function(){
    $(".pdp-popup").hide();
  });
  $(document).on("click", ".cs-product-template .cs-container .cs-grid .cs-content .product-form__controls-group label .icon-i", function(){
    $(".condition-grades").show();
  });
  $(document).on("click", ".condition-grades-content .fa-times", function(){
    $(".condition-grades").hide();
  });
  var getUrlParameter = function getUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;

      for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = sURLVariables[i].split('=');

          if (sParameterName[0] === sParam) {
              return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
          }
      }
      return false;
  };
  $(document).on("click", ".cs-selector label", function(){
    setTimeout(function(){
      display_varient_meta_data();
    }, 300);
  });
  $(document).on("click", "label.last .icon-i", function(){
      $(".pdpnote").show();
  });
  $(document).on("click", ".pdpnote .mypopup-close", function(e){
    e.preventDefault();
    $(".pdpnote").hide();
  });
  function display_varient_meta_data(){
    let cs_variant_label = "";
    if($('.last input[name="site_and_condition"]').length > 0){
      cs_variant_label = $('.last input[name="site_and_condition"]:checked').val().replace("_managed:", "").split("_")[0].toLowerCase().trim();
    }else if($('.last input[name="condition"]').length > 0){
      cs_variant_label = $('.last input[name="condition"]:checked').val().replace("_managed:", "").split("_")[0].toLowerCase().trim();
    }
    let description = "";
    let tag_check = $(".cs-variant-label-description").data("tag");
    if(cs_variant_label == "used and worn" || cs_variant_label == "worn"){
      description = "Used with considerable aesthetic blemishes, but still functions as it was designed.";
    }else if(cs_variant_label == "used and excellent" || cs_variant_label == "excellent"){
      description = tag_check == "no" ? "Used with minimal visible signs of wear and tear." : "Used with very few top-sheet scratches and chips and a near-perfect base";
    }else if(cs_variant_label == "used and good" || cs_variant_label == "good"){
      description = tag_check == "no" ? "Used with minor blemishes, but no functional issues." : "Used with light top-sheet scratching or chipping with a great base";
    }else if(cs_variant_label == "new"){
      description = "New, with original packaging and/or hang tags.";
    }else if(cs_variant_label == "like new" || cs_variant_label == "pristine"){
      if($(".cs-variant-label-description").hasClass("underwear")){
        description = "Unworn and unused but may not have original tags";
      }else if($(".cs-variant-label-description").hasClass("bikes")){
        description = "Never ridden, includes all parts and boxed up ready to be sent";
      }else if($(".cs-variant-label-description").hasClass("food")){
        description = "Uneaten, unopened - its not gross :-)";
      }else if($(".cs-variant-label-description").hasClass("footwear")){
        description = "Unworn, in-box with or without original packaging";
      }else{
        description = tag_check == "no" ? "New, without original packaging and/or hang tags." : "New, never mounted or ridden, but without original packaging";
      }
    }
    $(".cs-variant-label-description").html(description).show();
    if(description == ""){
      $(".cs-variant-label-description").hide();
    }else{
      $(".cs-variant-label-description").show();
    }
    let id = getUrlParameter("variant");
    if(id == "" && $("select#ProductSelect-custom-product-template").length > 0) id = $("select#ProductSelect-custom-product-template").val();
    if(id != "" && $(".variant-metadata .variant-"+id).length > 0){
      let json = $(".variant-metadata .variant-"+id).html();
      let html = "";
      if(json != ""){
        let obj = JSON.parse(json);
        if (typeof obj.instances[0][0].configs[0].metadata.inventory_item_ids_by_damage != "undefined") {
          let damage = obj.instances[0][0].configs[0].metadata.inventory_item_ids_by_damage;
          if(damage.length > 0){
            if(damage[0][0].length > 0){
              $.each(damage, function( index, value ) {
                if(value[0].length > 0){
                  html += "<div style='text-transform: capitalize;'>- "+value[0][0];
                  if(value[0].length > 1) html += " - "+value[0][1];
                  html += "</div>";
                }
              });
            }
          }
        }
      }
      if(html == ""){
        $(".variant-metadata-text").html("");
      }else{
        $(".variant-metadata-text").html(html+"<br>");
      }

      let product_data = JSON.parse($("#ProductJson-custom-product-template").html());
      let images = product_data.images;
      $.each( product_data.variants, function( key, value ) {
        if(value.id == id && value.featured_image != null){
          let featured_image = value.featured_image.src;
          $(".cs-images-desktop figure.cs-image:first-child").css("background", "url("+featured_image+")")
          $(".cs-images-desktop figure.cs-image:first-child .cs-product-image").attr("src", featured_image);
          let idx = 1;
          $.each(images, function( k, v ) {
            if(v != featured_image){
              idx ++;
              $(".cs-images-desktop figure.cs-image:nth-child("+idx+")").css("background", "url("+v+")")
              $(".cs-images-desktop figure.cs-image:nth-child("+idx+") .cs-product-image").attr("src", v);
            }else{
              $(".swiper-pagination>span:nth-child("+idx+")").click();
            }
          });
        }
      });
    }
  }
  if($(".cs-variant-label").length > 0){
    let conditionLabel = "";
    $(".last>.cs-selector").each(function(){
      const labelText = $(this).find("label").text().toLowerCase().trim();
      if(labelText == "new"){
        conditionLabel = "New";
        return false;
      }
    });
    const selectorsCount = $(".last > .cs-selector").length;
    if(selectorsCount > 1 && conditionLabel){
      conditionLabel = "New &amp; Used";
    }else if(selectorsCount > 0 && !conditionLabel){
      conditionLabel = "Used";
    }
    $(".condition-value").html(conditionLabel);
    display_varient_meta_data();
  }

  //----- OPEN
  $('.mypopbtn').on('click', function(e)  {
    e.preventDefault();
    $('body').find('.mypopup').fadeIn(350);
  });
  //----- CLOSE
  $('.mypopup-close').on('click', function(e)  {
    e.preventDefault();
    $('body').find('.mypopup').fadeOut(350);
  });
  $(document).on("click", ".cs-images-mobile img.plus", function(){
    const step = 0.2;
    var zoom = $(".swiper-slide.swiper-slide-active").attr("zoom");
    if(zoom < 1 || typeof zoom == "undefined"){
      zoom = 1;
    }else{
      zoom = parseFloat(zoom)
    }
    zoom = zoom + step;
    $(".swiper-slide.swiper-slide-active").attr("zoom",zoom);
    $(".swiper-slide.swiper-slide-active img").css("transform", "scale("+zoom+")");
  });
  $(document).on("click", ".cs-images-mobile img.minus", function(){
    const step = 0.2;
    var zoom = $(".swiper-slide.swiper-slide-active").attr("zoom");
    if(typeof zoom == "undefined"){
      zoom = 1;
    }else{
      zoom = parseFloat(zoom)
    }
    if(zoom > 1) zoom = zoom - step;
    $(".swiper-slide.swiper-slide-active").attr("zoom",zoom);
    $(".swiper-slide.swiper-slide-active img").css("transform", "scale("+zoom+")");
  });
  $(document).on("click", ".cs-images-mobile img.reset", function(){
    $(".swiper-slide.swiper-slide-active").attr("zoom",1);
    $(".swiper-slide.swiper-slide-active img").css("transform", "scale("+1+")");
  });
  /* PDP Script */
  if ( $('body').hasClass('template-product') ) {

    /* PDP Variation change function */
    $('form.product-form input[type=radio]').change(function() {

      /* Update price off value */
      $('.price__percentage').addClass('d-none');
      setTimeout(function() {
        if ( $('.product-single__meta [data-price]').hasClass('price--on-sale') ) {
          let reg_price = parseFloat($('.price__sale [data-regular-price]').text().replace('$','').replace(/,/g, ""));
          let sale_price = parseFloat($('[data-sale-price]').text().replace('$','').replace(/,/g, ""));
          let p_off = Math.round((reg_price - sale_price) / reg_price * 100);
          $('.price__percentage span').text(p_off + '% OFF');
          $('.price__percentage').removeClass('d-none');
        }
      }, 20);

    });

  }


  /* Header navigation Script */
  navSelect();
  $(window).on('resize', function() {
    navSelect();
  });

  $('input#search_brand').on('focus', function() {
    $('.search_wrap').addClass('input_focus');
  });

  $('input#search_brand').on('blur', function() {
    $(this).val('');
    setTimeout(function() {
      $('.search_wrap').removeClass('input_focus');
      $('.brand_wrapper').removeClass('input_active');
      $('.brand_item').removeClass('inactive');
    }, 100);
  });

  $('input#search_brand').on('click', function() {
    $('.brand_wrapper').toggleClass('input_active');
  });

  $('input#search_brand').on('input', function() {
    var key = $(this).val();
    $('.brand_item').addClass('inactive');
    $('.brand_item').each(function(i, e) {
      if ( $(this).text().toLowerCase().includes(key) ) {
        $(this).removeClass('inactive');
      }
    });
  });

  $('.menu_heading:first-child, .featured_title, .brand_col_title').on('click', function() {

    if ( $(this).hasClass('opened') ) {
      $(this).removeClass('opened');
      $(this).siblings().slideUp(200, function() {

      });
    } else {
      $(this).addClass('opened');
      $(this).siblings().slideDown(300, function() {

      });
    }

  });


  /* Custom Signup form Script */
  $('.collection_banner a').on('click', function() {

    $('#cus_signup_popup').addClass('active');

  });

  $('.cus_form_overlay, .cus_form_close').on('click', function() {

    $('#cus_signup_popup').removeClass('active');
    $('.cus_form_result').removeClass('failed');
    $('.cus_form_result').removeClass('active')
    $('.cus_form_content').addClass('active');

    $('#human_brand option:first').prop('selected', true);
    $('#human_product_type option:first').prop('selected', true);
    $('#human_descriptor option:first').prop('selected', true);
    $('#human_size option:first').prop('selected', true);
    $('#cus_form_product_wrap').removeClass('active');
    $('#cus_form_descriptor_wrap').removeClass('active');
    $('#cus_form_size_wrap').removeClass('active');
    $('#human_fname').val('');
    $('#human_lname').val('');
    $('#human_email').val('');
    $('#cus_form_term_of_use').prop('checked', false);
    $('.cus_form_submit').removeClass('active');
    $('.cus_form_dropdown').removeClass('cus_error');
    $('.cus_form_input').removeClass('cus_error');

  });

  $('[name="cus_form_term_of_use"]').on('change', function() {

    if ( $(this).is(':checked') ) {
      $('.cus_form_submit').addClass('active');
    } else {
      $('.cus_form_submit').removeClass('active');
    }
  });

  $('#human_brand').on('change', function() {

    var selected_brand = $(this).find('option:selected').val();
    if ( selected_brand == '' ) {
      $('#cus_form_product_wrap').removeClass('active');
    } else {
      $('#cus_form_product_wrap').addClass('active');
    }
    $('#human_product_type option:first').prop('selected', true);
    $('#human_descriptor option:first').prop('selected', true);
    $('#human_size option:first').prop('selected', true);
    $('#cus_form_descriptor_wrap').removeClass('active');
    $('#cus_form_size_wrap').removeClass('active');

  });

  $('#human_product_type').on('change', function() {

    var selected_type = $(this).find('option:selected').val();
    $('#human_descriptor option:first').prop('selected', true);
    if ( selected_type == 'Sleeping Pad' ) {
      $('#cus_form_descriptor_wrap').removeClass('active');
      $('#human_size option:first').prop('selected', true);
      $('#cus_form_size_wrap').addClass('active');
    } else {
      if ( selected_type == '' ) {
        $('#cus_form_descriptor_wrap').removeClass('active');
      } else {
        $('#cus_form_descriptor_wrap').addClass('active');
      }
      $('#human_size option:first').prop('selected', true);
      $('#cus_form_size_wrap').removeClass('active');
    }

  });

  $('#human_descriptor').on('change', function() {

    var selected_descriptor = $(this).find('option:selected').val();
    if ( selected_descriptor == '' || $('#human_descriptor').hasClass('no_size') ) {
      $('#human_size option:first').prop('selected', true);
      $('#cus_form_size_wrap').removeClass('active');
    } else {
      $('#cus_form_size_wrap').addClass('active');
    }

  });

  $('.cus_form_submit').on('click', function() {

    if ( $(this).hasClass('active') ) {

      var flag = true;
      $('.cus_form_dropdown_wrap.active').each(function(i, e) {
        if ( $(this).attr('id') != 'cus_form_size_wrap' ) {
          var data = $(this).find('.cus_form_dropdown').val();
          if ( data == '' ) {
            $(this).find('.cus_form_dropdown').addClass('cus_error');
            flag = false;
          } else {
            $(this).find('.cus_form_dropdown').removeClass('cus_error');
          }
        }
      });

      var fname = $.trim( $('#human_fname').val() );
      if ( fname == '' ) {
        $('#human_fname').addClass('cus_error');
        flag = false;
      } else {
        $('#human_fname').removeClass('cus_error');
      }
      var lname = $.trim( $('#human_lname').val() );
      if ( lname == '' ) {
        $('#human_lname').addClass('cus_error');
        flag = false;
      } else {
        $('#human_lname').removeClass('cus_error');
      }
      var email = $('#human_email').val();
      if ( email == '' || email.indexOf('@') === -1 ) {
        $('#human_email').addClass('cus_error');
        flag = false;
      } else {
        $('#human_email').removeClass('cus_error');
      }

      if ( flag ) {
        $('.cus_form_loading').addClass('active');
        $(this).addClass('loading');
        var formData = $('#cus_form').serialize();
        $.ajax({
          url: '/apps/backend/customer_subscription_signup',
          method: 'POST',
          data: formData,
          dataType: 'json'
        })
        .done(function(response) {
          console.log('Success:', response);
          $('.cus_form_loading').removeClass('active');
          $('.cus_form_submit').removeClass('loading');
          $('.cus_form_content').removeClass('active');
          $('.cus_form_result').addClass('success');
          $('.cus_form_result').addClass('active');
        })
        .fail(function(xhr, status, error) {
          console.log('Error:', error);
          $('.cus_form_loading').removeClass('active');
          $('.cus_form_submit').removeClass('loading');
          $('.cus_form_content').removeClass('active');
          $('.cus_form_result').addClass('failed');
          $('.cus_form_result').addClass('active');
        })
        .always(function() {
          console.log('Request completed');
        });
      }

    }

  });

});

function navSelect() {

  var num;
  if ( $(window).width() > 900 ) {
    $('.nav_item').hover(
      function() {
        if ( $(window).width() > 900 ) {
        num = $(this).attr('nav_num');
        $('.nav_item').removeClass('nav_active');
        $(this).addClass('nav_active');
        $('.nav_panel').removeClass('panel_active');
        $('#nav_panel' + num).addClass('panel_active');
        $('.nav_wrapper>.nav_content').addClass('active');
        $('.nav_overlay').addClass('overlay_active');
        }
      }, function() {
        if ( $(window).width() > 900 ) {
        num = $(this).attr('nav_num');
        if ( $('.nav_wrapper:hover').length == 0 ) {
          $(this).removeClass('nav_active');
          $('.nav_header').removeClass('active');
          $('.nav_wrapper>.nav_content').removeClass('active');
          $('.nav_overlay').removeClass('overlay_active');
          $("i.mobile_menu_close").removeClass("act");
          $("i.mobile_menu").addClass("act");
        }
        }
      }
    );
    $('.nav_item_link').hover(
      function() {
          $('.nav_panel').removeClass('panel_active');
          $('.nav_header').removeClass('active');
          $('.nav_item').removeClass('nav_active');
          $('.nav_content').removeClass('active');
          $('.nav_overlay').removeClass('overlay_active');
          $("i.mobile_menu_close").removeClass("act");
          $("i.mobile_menu").addClass("act");
      }
    );
    $(document).on('mousemove', '.nav_overlay', function(e) {
      if ( $('.nav_wrapper:hover').length == 0 ) {
        $('.nav_panel').removeClass('panel_active');
        $('.nav_item').removeClass('nav_active');
        $('.nav_header').removeClass('active');
        $('.nav_content').removeClass('active');
        $('.mob_nav_head').removeClass('m_nav_active');
        $('.menu_heading').removeClass('opened');
        $(".mob_nav_content").hide();
        $(".mob_nav_content .menu_item_wrap").hide();
        $('.nav_overlay').removeClass('overlay_active');
        $("i.mobile_menu_close").removeClass("act");
        $("i.mobile_menu").addClass("act");
      }
    });
  } else {
    $('.mob_nav_head').removeClass('m_nav_active');
    $(".mob_nav_content").hide();
  }
}

$(document).on('click', '.site-header__icon i.fa-search', function() {
  $(".makeStyles-searchButton-3").click();
});
$(document).on('click', '.mob_nav_head', function() {
    if($(this).hasClass("m_nav_active")){
      $(this).removeClass('m_nav_active');
      $(this).find("+ .mob_nav_content").slideUp(200, function() {});
    }else{
      $(this).addClass('m_nav_active');
      $(this).find("+ .mob_nav_content").slideDown(200, function() {});
    }
    $('.nav_overlay').addClass('overlay_active');
});

$(document).on('click', '.nav_overlay', function(event) {
  var $element = $(".nav_header");
  if (!($element.is(event.target) || $element.has(event.target).length > 0)) {
    $('.mob_nav_head').removeClass('m_nav_active');
    $('.menu_heading').removeClass('opened');
    $(".mob_nav_content").hide();
    $(".menu_item_wrap").hide();


    $('.nav_header').removeClass('active');
    $('.nav_item').removeClass('nav_active');
    $('.nav_content').removeClass('active');
    $('.nav_overlay').removeClass('overlay_active');
    $("i.mobile_menu_close").removeClass("act");
    $("i.mobile_menu").addClass("act");
  }
});
$(document).on("click", "i.mobile_menu_close", function(e){
    $('.mob_nav_head').removeClass('m_nav_active');
    $('.menu_heading').removeClass('opened');
    $(".mob_nav_content").hide();
    $(".menu_item_wrap").hide();
    $('.nav_header').removeClass('active');
    $('.nav_item').removeClass('nav_active');
    $('.nav_content').removeClass('active');
    $('.nav_overlay').removeClass('overlay_active');
    $("i.mobile_menu_close").removeClass("act");
    $("i.mobile_menu").addClass("act");
});
$(document).on("click", "i.mobile_menu", function(e){
  $('.nav_content').removeClass('active');
  $('.nav_header').addClass('active');
  $('.nav_overlay').addClass('overlay_active');
  $(this).removeClass("act");
  $("i.mobile_menu_close").addClass("act");
});
$(document).on("click", ".nav_panel.panel_active a.back1", function(e){
  $('.nav_item').removeClass('nav_active');
  $('.nav_panel').removeClass('panel_active');
  $('.nav_content').removeClass('active');
});
$(document).on("click", ".makeStyles-searchForm-4 .makeStyles-searchButton-3", function(e){
  if(screen.width < 768){
    e.preventDefault();
    $(".makeStyles-searchForm-4 input[type=text]").val(" ").click();
  }
});
$(document).on("click", "#Quantity-decrease", function(e){
  e.preventDefault();
  var currentValue = parseInt($('#Quantity-custom-product-template').val());
  if (currentValue > 1) {
    $('#Quantity-custom-product-template').val(currentValue - 1);
  }
});
$(document).on("click", "#Quantity-increase", function(e){
  e.preventDefault();
  var currentValue = parseInt($('#Quantity-custom-product-template').val());
  $('#Quantity-custom-product-template').val(currentValue + 1);
});